import React from 'react';
import './HolisticDevelopmentSection.css';
import { FaPalette, FaUsers, FaSeedling, FaCalendarAlt } from 'react-icons/fa';

const HolisticDevelopmentSection = () => {
  const activities = [
    {
      icon: <FaPalette />,
      title: 'Creative Arts',
      description: 'Express yourself through various art forms and cultural activities'
    },
    {
      icon: <FaUsers />,
      title: 'Team Projects',
      description: 'Collaborate on real-world projects to develop leadership skills'
    },
    {
      icon: <FaSeedling />,
      title: 'Personal Growth',
      description: 'Engage in workshops and activities that foster self-development'
    }
  ];

  return (
    <section className="holistic-development-section">
      <div className="container">
        <h2 className="section-title">Nurturing Minds & Beyond</h2>
        <p className="section-description">
          We believe in shaping well-rounded individuals. Alongside a strong academic foundation, 
          we host daily activities that inspire creativity, teamwork, and growth.
        </p>
        
        <div className="activities-grid">
          {activities.map((activity, index) => (
            <div className="activity-card" key={index}>
              <div className="activity-icon">
                {activity.icon}
              </div>
              <h3 className="activity-title">{activity.title}</h3>
              <p className="activity-description">{activity.description}</p>
            </div>
          ))}
        </div>

        <button className="schedule-button" onClick={() => window.open('https://adci-calendar.netlify.app/', '_blank')}>
          <FaCalendarAlt className="calendar-icon" />
          <span>View Schedule</span>
        </button>
      </div>
    </section>
  );
};

export default HolisticDevelopmentSection;
